import * as Configuration from 'src/ajs-app/app.constants.js';
import { WhatsappAccountOriginEnum } from 'src/app/parameters/add-account/whatsapp-cloud-api/shared/models/whatsapp-account-origin.enum';

AccountEditionController.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$translate',
  'TopToolbarFactory',
  'AccountsFactory',
  'AlertingFactory',
  'company',
  'sites',
  'MediasFactory',
  'ConfirmationFactory',
  'siteGroups',
  'siteGroupsMap',
  'GbmFactory',
  'WebchatFactory',
  'WhatsappFactory',
  'KakaotalkFactory'
];

export function AccountEditionController(
  $scope,
  $state,
  $stateParams,
  $translate,
  TopToolbarFactory,
  AccountsFactory,
  AlertingFactory,
  company,
  sites,
  MediasFactory,
  ConfirmationFactory,
  siteGroups,
  siteGroupsMap,
  GbmFactory,
  WebchatFactory,
  WhatsappFactory,
  KakaotalkFactory
) {

  $scope.WhatsappAccountOriginEnum = WhatsappAccountOriginEnum;

  $scope.goBack = goBack;
  $scope.onAuthClick = onAuthClick;
  $scope.isNonReauthorizableSite = isNonReauthorizableSite;

  $scope.updateWebchatAllowedDomains = updateWebchatAllowedDomains;
  $scope.saveWebchatAllowedDomains = saveWebchatAllowedDomains;

  $scope.whatsappProfileChanged = whatsappProfileChanged;
  $scope.saveWhatsappProfile = saveWhatsappProfile;
  $scope.onWhatsAppPhotoUploadClick = onWhatsAppPhotoUploadClick;
  $scope.deleteWhatsappPhoto = deleteWhatsappPhoto;

  $scope.migrateToWhatsappCloudApi = migrateToWhatsappCloudApi;

  $scope.inMessageSiteType = WebchatFactory.getType();
  $scope.kakaotalkSiteType = KakaotalkFactory.getType();
  $scope.gbmSiteType = GbmFactory.getType();
  $scope.whatsappSiteType = WhatsappFactory.getType();

  init();

  // Go back to accounts table
  function goBack() {
    AccountsFactory.redirectToAccountsPage($state);
  }

  function onAuthClick() {
    AccountsFactory.authAccount($stateParams.companyId, $stateParams.id)
      .then(res => window.location.href = res.data,
        AlertingFactory.httpErrorHandler());
  }

  function saveWebchatAllowedDomains() {
    ConfirmationFactory.materialConfirmDialog('accounts/edition/webchat/allowed-domains/confirm-save')
      .then(function () {
        AccountsFactory.updateWebchatAllowedDomains($stateParams.companyId, $scope.account.id, $scope.allowedDomains)
          .then(
            () => {
              $scope.savedAllowedDomains = angular.copy($scope.allowedDomains);
              $scope.isAllowedDomainsModified = false;
              AlertingFactory.info('account/updated/ok');
            },
            AlertingFactory.httpErrorHandler()
          )
      });
  }

  function updateWebchatAllowedDomains() {
    $scope.isAllowedDomainsModified = !angular.equals($scope.allowedDomains, $scope.savedAllowedDomains);
  }

  function resetAccountAfterUpdate(res) {
    $scope.account = { ...res.data, siteGroup: siteGroupsMap.get(res.data.site_group_id || res.data.site_group?.id) };
    TopToolbarFactory.setTitle($scope.account.name, $scope);
    $scope.eligibleGroups = [{ name: $translate.instant('none'), id: null }].concat(siteGroups.filter(gr => gr.type === $scope.account.type));

    if ($scope.account.type === $scope.twitterSiteType) {
      $scope.twitterSites = sites.filter(site => site.type === 2);
    }

    if ($scope.account.type === $scope.inMessageSiteType) {
      $scope.externalId = $scope.account.authorized_user?.external_id;

      AccountsFactory.getWebchatAllowedDomains($stateParams.companyId, $scope.account.id)
        .then(
          res => {
            $scope.savedAllowedDomains = res.data.allowed_domains;
            $scope.allowedDomains = angular.copy($scope.savedAllowedDomains);
          },
          AlertingFactory.httpErrorHandler()
        )
    }

    if ($scope.account.type === $scope.whatsappSiteType) {
      initWhatsappProfile();
      AccountsFactory.getWhatsappProfile(company.id, $scope.account.id).then(
        response => $scope.whatsappProfile = response.data,
        error => {
          if (error.status === 400) {
            // work around to avoid error message for WA 360 sandbox
            console.log('editing profile is not support in WA 360 dialog sandbox');
          }
          else {
            AlertingFactory.httpErrorHandler();
          }
        }
      );
    }
  }

  function isNonReauthorizableSite(siteType) {
    return [$scope.inMessageSiteType, $scope.gbmSiteType].includes(siteType);
  }

  function whatsappProfileChanged() {
    $scope.hasWhatsappProfileChanged = true;
  }

  function saveWhatsappProfile(whatsappProfile) {
    const data = {
      about: whatsappProfile.about,
      address: whatsappProfile.address,
      description: whatsappProfile.description,
      email: whatsappProfile.email,
      vertical: whatsappProfile.vertical,
      websites: whatsappProfile.websites
    };
    AccountsFactory.setWhatsappProfile(company.id, $scope.account.id, data).then(
      () => {
        $scope.hasWhatsappProfileChanged = false;
        AlertingFactory.info('account/updated/ok');
      },
      AlertingFactory.httpErrorHandler()
    );
  }

  function onWhatsAppPhotoUploadClick() {
    angular.element('#whatsapp-photo-input').click();
  }

  function deleteWhatsappPhoto() {
    AccountsFactory.removeWhatsappProfilePhoto(company.id, $scope.account.id).then(
      () => {
        $scope.whatsappProfile.photo = null;
        AlertingFactory.info('account/updated/ok');
      },
      AlertingFactory.httpErrorHandler()
    );
  }

  function initWhatsappProfile() {
    $scope.hasWhatsappProfileChanged = false;
    $scope.whatsappProfile = {
      photo: null,
      about: '',
      address: '',
      description: '',
      email: '',
      vertical: '',
      websites: ['', '']
    };
    $scope.whatsappProfileVerticalOptions = [{
      id: 'Automotive',
      label: $translate.instant('parameters/accounts/whatsapp/options/vertical-option-automotive')
    }, {
      id: 'Beauty, Spa and Salon',
      label: $translate.instant('parameters/accounts/whatsapp/options/vertical-option-beauty-spa-salon')
    }, {
      id: 'Clothing and Apparel',
      label: $translate.instant('parameters/accounts/whatsapp/options/vertical-option-clothing-apparel')
    }, {
      id: 'Education',
      label: $translate.instant('parameters/accounts/whatsapp/options/vertical-option-education')
    }, {
      id: 'Entertainment',
      label: $translate.instant('parameters/accounts/whatsapp/options/vertical-option-entertainment')
    }, {
      id: 'Event Planning and Service',
      label: $translate.instant('parameters/accounts/whatsapp/options/vertical-option-event-planning-service')
    }, {
      id: 'Finance and Banking',
      label: $translate.instant('parameters/accounts/whatsapp/options/vertical-option-finance-banking')
    }, {
      id: 'Food and Grocery',
      label: $translate.instant('parameters/accounts/whatsapp/options/vertical-option-food-grocery')
    }, {
      id: 'Public Service',
      label: $translate.instant('parameters/accounts/whatsapp/options/vertical-option-public-service')
    }, {
      id: 'Hotel and Lodging',
      label: $translate.instant('parameters/accounts/whatsapp/options/vertical-option-hotel-lodging')
    }, {
      id: 'Medical and Health',
      label: $translate.instant('parameters/accounts/whatsapp/options/vertical-option-medical-health')
    }, {
      id: 'Non-profit',
      label: $translate.instant('parameters/accounts/whatsapp/options/vertical-option-non-profit')
    }, {
      id: 'Professional Services',
      label: $translate.instant('parameters/accounts/whatsapp/options/vertical-option-professional-service')
    }, {
      id: 'Shopping and Retail',
      label: $translate.instant('parameters/accounts/whatsapp/options/vertical-option-shopping-retail')
    }, {
      id: 'Travel and Transportation',
      label: $translate.instant('parameters/accounts/whatsapp/options/vertical-option-travel-transportation')
    }, {
      id: 'Restaurant',
      label: $translate.instant('parameters/accounts/whatsapp/options/vertical-option-restaurant')
    }, {
      id: 'Other',
      label: $translate.instant('parameters/accounts/whatsapp/options/vertical-option-other')
    }];
    $scope.$watch('whatsapp.profile.picture', file => {
      if (file) {
        MediasFactory.uploadWhatsappProfilePhoto(company.id, $scope.account.id, file,
          response => {
            $scope.whatsappProfile.photo = response.data.link;
            AlertingFactory.info('account/updated/ok');
          },
          response => {
            AlertingFactory.alertHTTPError(response);
          },
        );
      }
    });
  }


  function init() {
    // Labels
    $scope.backToLabel = $translate.instant('accounts/edition/back_to_accounts_table');

    $scope.delays = [0.0166, 0.0833, 0.5, 1, 2, 4, 8, 24, 48, 72, 96, 120].map(i => ({
      id: Math.ceil(i * 3600),
      label: $translate.instant(`account/conversations/delay/${i}h`)
    }));

    if ($stateParams.error) {
      $scope.authError = $translate.instant($stateParams.error);
    }

    TopToolbarFactory.setFirstLevelNavTranslation('parameters/links_menu/accounts', $scope, () => AccountsFactory.redirectToAccountsPage($state));

    AccountsFactory.getAccountInfo($stateParams.companyId, $stateParams.id)
      .then(res => resetAccountAfterUpdate(res),
        AlertingFactory.httpErrorHandler());

    AccountsFactory.getAuthLog($stateParams.companyId, $stateParams.id)
      .then(res => $scope.authLog = res.data.authorization_logs.length > 0 ? res.data.authorization_logs[0] : null,
        AlertingFactory.httpErrorHandler());

    AccountsFactory.getAccountConversationConfig($stateParams.companyId, $stateParams.id)
      .then(res => {
        $scope.conversationConfig = res.data;

        $scope.currentDelay = $scope.delays.filter(i => i.id === $scope.conversationConfig.delay_s)[0];
        $scope.delayIsActive = $scope.conversationConfig.state === 'active';
      },
        AlertingFactory.httpErrorHandler());
  }

  function migrateToWhatsappCloudApi() {
    const target = $state.href('auth.alcmeon.fuse.parameters.whatsapp-cloud-api.migrate', {
      companyId: $stateParams.companyId,
      siteId: $scope.account.id,
      origin: $scope.account.eligible_cloud_api_migration,
    });
    window.open(`${Configuration.constants.frontendBaseUrl}${target}`, '_blank').focus();
  }
}
